import type { Release } from '../../../types';

const outOfOrder: Release = {
  name: 'out of order',
  short_description: 'Downtempo & Atmospheric IDM Journey',
  description:
    "Out of Order is a rich album delving into glitchy downtempo rhythms, deep dub-infused basslines, and hypnotic atmospheric layers. Featuring standout tracks like 'fight for rights', 'whether be', and the epic 10-minute soundscape 'fearless world', the album exemplifies joev's mastery of introspective electronic production.",
  tracklist: [
    {
      trackname: 'out of order',
      duration: '02:34 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/out-of-order',
      },
    },
    {
      trackname: 'how to',
      duration: '03:48 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/how-to',
      },
    },
    {
      trackname: 'fight for rights',
      duration: '05:52 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/fight-for-rights',
      },
    },
    {
      trackname: 'whether be',
      duration: '04:19 min',
      tracknr: '04',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/whether-be',
      },
    },
    {
      trackname: 'rise up',
      duration: '05:14 min',
      tracknr: '05',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/rise-up',
      },
    },
    {
      trackname: 'inseparable',
      duration: '04:26 min',
      tracknr: '06',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/inseparable',
      },
    },
    {
      trackname: 'fearless world',
      duration: '09:58 min',
      tracknr: '07',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/fearless-world',
      },
    },
    {
      trackname: 'ahjo (bonus)',
      duration: '03:00 min',
      tracknr: '08',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/ahjo-bonus',
      },
    },
  ],
  date: '04-2016',
  bgColor: '#89837f',
  cover: 'joevnoise_out-of-order.png',
  detail_link: 'out-of-order',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/out-of-order-2',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/sets/out-of-order',
    },
  ],
};

export default outOfOrder;
